import { render, staticRenderFns } from "./CollapseFieldDetail.vue?vue&type=template&id=600a88c8&"
import script from "./CollapseFieldDetail.vue?vue&type=script&lang=js&"
export * from "./CollapseFieldDetail.vue?vue&type=script&lang=js&"
import style0 from "./CollapseFieldDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports